import "./layout/general.css"
import "./layout/header.css"
import "./pages/index.css"
import "./pages/auth.css"
import "./app/app.scss"
import "./app/modal.scss"
import "./app/dashboard.css.scss"
import "./app/side-menu.css.scss"
import "./app/filters.css.scss"